import AccountPane from './AccountPane';

export default AccountPane;
